/* eslint-disable no-unused-vars */
import React from 'react';
import style from './requestItem.module.scss';
import Indicator from 'components/adminList/components/indicator/indicator';
import UserData from 'components/adminList/components/userData/userData';
import { User } from 'store/types';
import Button from 'controls/buttons/submit';
import {
  sendVerdict,
  selectIsVerdictPending,
  selectPendingVerdict,
} from 'store/admin/adminSlice';
import { useAppSelector, useAppDispatch } from 'store/hooks';
import cx from 'classnames';

export default function RequestItem({ user }: { user: User }) {
  const dispatch = useAppDispatch();
  const pendingVerdicts = useAppSelector(selectPendingVerdict);
  const isPending = useAppSelector(selectIsVerdictPending);

  const thisVerdict = pendingVerdicts[user._id];
  const isThisLoading = isPending && thisVerdict;

  return (
    <div className={'adminListItem'}>
      <Indicator bgColor={'#FF6F97'}></Indicator>
      <span className={style.type}>Заявка на регистрацию</span>
      <div className={'vertical'}></div>
      <UserData user={user}></UserData>
      <div className={style.buttons}>
        <Button
          className={style.accept}
          onClick={() =>
            !isThisLoading &&
            dispatch(
              sendVerdict({
                _id: user._id,
                verdict: true,
              })
            )
          }
          wrapper={{
            loading: isThisLoading && thisVerdict?.is_active === true,
          }}
        >
          {!(isThisLoading && thisVerdict?.is_active === true) && 'Принять'}
        </Button>
        <Button
          className={cx('btn-cancel')}
          onClick={() =>
            !isThisLoading &&
            dispatch(
              sendVerdict({
                _id: user._id,
                verdict: false,
              })
            )
          }
          wrapper={{
            className: style.dismissWrapper,
            loading: isThisLoading && thisVerdict?.is_active === false,
          }}
        >
          {!(isThisLoading && thisVerdict?.is_active === false) && 'Отклонить'}
        </Button>
      </div>
    </div>
  );
}
